<template>
  <KpiKorporatForm mode="Ubah" module="Indikator Kinerja"> </KpiKorporatForm>
</template>

<script>
import KpiKorporatForm from './form-kpi';
import { onBeforeRouteLeave } from 'vue-router';
import { useStore } from 'vuex';

const KpiKorporatUpdate = {
  name: 'KpiKorporatUpdate',
  components: { KpiKorporatForm },
  setup() {
    const store = useStore();
    onBeforeRouteLeave(() => {
      store.commit('axiosResetState');
    });
  },
};

export default KpiKorporatUpdate;
</script>
